module.exports = __webpack_public_path__ + "static/media/pwm.97f50c69.jpg";